import React from 'react';
import IntegrationsList from './components/integrations-lists';

const AllIntegrations: React.FC = () => {
  return (
    <div className="w-full h-full">
      <IntegrationsList />
    </div>
  );
};

export default AllIntegrations;
